import React from "react";
import { APP_TITLE } from "../constants/title";
import { LANDING_PAGES } from "../constants/landingPages";
import Layout from "../components/Layout/Layout";
import Container from "@material-ui/core/Container";
import { Helmet } from "react-helmet";
import LpCategories from "../components/LpCategories/LpCategories";

const LandingPageView = (props) => {
  const { url } = props;

  const lp = LANDING_PAGES.find((lp) => lp.url === url);

  return (
    <>
      <Layout title={lp.title}>
        <Container className={"landingPageView"}>
          {lp.content}
          <LpCategories />
        </Container>
      </Layout>
    </>
  );
};

export default LandingPageView;
